import axios from "axios";
import { refreshTokens } from "./AuthService";
import Cookies from "universal-cookie";
import { jwtDecode } from 'jwt-decode';

const client = axios.create({
    //baseURL: "http://localhost:8000/admin/config"
    baseURL: "https://vp-backend-ysy4bqirgq-uc.a.run.app/admin/config" 
});

const cookies = new Cookies();
client.defaults.headers.common['Authorization'] = 'Bearer ' + cookies.get("jwt_authorization");


client.interceptors.response.use(resp => resp, async error => {   
    if (error.response.status === 401) {
        const data = {
            'refresh_token': cookies.get("refresh_token")
        }
        const response = await refreshTokens(JSON.stringify(data));

        if (response.id_token !== null) {
            client.defaults.headers.common['Authorization'] = 'Bearer ' + response.id_token;
            var userObject = jwtDecode(response.id_token);
            cookies.set("jwt_authorization", response.id_token, {
                expires: new Date(userObject.exp * 1000),
            });
            cookies.set("access_token", response.access_token, {
                expires: new Date(userObject.exp * 1000),
            });
            window.location.reload();
            return client(error.config);
        }
    }
});

export const getConfig = async (configKey) => {
    const response = await client.get('/' + configKey);
    return response.data;
};

export const setConfig = async (configKey, configValue) => {
    const response = await client.put('/' + configKey, { config_value: configValue }, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    return response;
};
